import React, { useState } from "react";
import { login } from "../../../config/LiveApi";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const Modal = ({ callApi, setIsModal }) => {
  const [password, setPassword] = useState("");
  const userEmail = useSelector(store => store.userReducer.userEmail);

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    console.log("Checking password");

    // post("v1/admin/auth/login", { email: userEmail, password })
    //   .then(() => {
        
    //     callApi();
    //     setPassword("");
    //   })
    //   .catch(() => {
    //     toast.error("Incorrect password");
    //   });

    login(userEmail, password)
    .then(() => {
        callApi();
        setPassword("");
    })
    .catch(() => {
        toast.error("Incorrect password");
    })
    
    setIsModal(false);
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <form onSubmit={(e) => handlePasswordSubmit(e)}>
          <p className="label-data">Enter your password</p>
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />

          <button type="submit" className="auth-submit-btn">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default Modal;
